import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { combineLatest, Subscription } from 'rxjs';
import { IssueTypes } from 'src/app/lib/shared/globals';
import { IssueCategory } from '../../../classes';
import { IIssueProviderService, ISSUE_PROVIDER_SERVICE } from '../../../interfaces';
import { IssueService } from '../../../services/issue.service';

@Component({
  selector: 'app-select-category-form',
  templateUrl: './select-category-form.component.html',
  styleUrls: ['./select-category-form.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectCategoryFormComponent),
      multi: true
    }
  ]
})
export class SelectCategoryFormComponent implements ControlValueAccessor, OnInit {

  @Input() label: string = "Kategorie";
  @Input() placeholder: string;
  @Input() showCurrentValues: boolean = false;
  @Input() appearance: string = 'fill';

  categories: IssueCategory[] = [];

  formControl: FormControl = new FormControl();

  _subscriptions: Subscription[] = [];

  /**
   * the constructor creates a new instance of the component
   * @param _formBuilder 
   * @param _dataService 
   */
  constructor(
    @Inject(ISSUE_PROVIDER_SERVICE) private _service: IIssueProviderService,
    private _issueService: IssueService
  ) { }
  /**
   * the method is called on component disposition
   */
  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }
  /**
   * the method is called on component initalization
   */
  ngOnInit(): void {
    this._subscriptions.push(
      combineLatest([
        this._issueService.getAllIssueCategories(true),
        this._service.getCurrentIssueType()
      ]).subscribe({
        next: ([categories, typeId]) => this.setAvailableCategories(categories, typeId)
      })
    );
  }

  public onTouched: () => void = () => { };

  registerOnChange(fn: any): void {
    this
      ._subscriptions
      .push(
        this
          .formControl
          .valueChanges
          .subscribe(fn)
      );
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }


  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  /**
   * the method sets the issue categories in accordance to the issue type
   */
  setAvailableCategories(categories: IssueCategory[], type: number = IssueTypes.Issue) {

    switch (type) {

      case IssueTypes.Change:
        this.categories = categories.filter(x => x.ischangecategory);
        break;

      case IssueTypes.Incident:
        this.categories = categories.filter(x => x.isincidentcategory);
        break;

      case IssueTypes.Project:
        this.categories = categories.filter(x => x.isprojectcategory);
        break;

      default:
        this.categories = categories.filter(x => x.isissuecategory);
        break;

    }

  }

  writeValue(val: any): void {
    if (val) this.formControl.setValue(val);
  }

}
